import { createTopLevelAction } from "../../core/make-action";
import TopLevelMethod from "../../core/TopLevelMethod";
import { getLabEnabledStatuses, getUserInfoLoadStatus } from "./selectors";
import { DetailedLoadStatus } from "../../../../../../common/utils/async-status";
import { getVstFromFullLocale } from "../../../../../../common/utils/locale";

const fetchUserInfoBase = createTopLevelAction(TopLevelMethod.GET_USER_INFO);
const setUserInfo = createTopLevelAction(TopLevelMethod.SET_USER_INFO);
const signOut = createTopLevelAction(TopLevelMethod.SIGN_OUT);
export const enableLab = createTopLevelAction(TopLevelMethod.ENABLE_LAB);
export const disableLab = createTopLevelAction(TopLevelMethod.DISABLE_LAB);

export const toggleLab = (id) => {
  return function (dispatch, getState) {
    const enabledStatuses = getLabEnabledStatuses(getState());
    enabledStatuses[id]?.enabled
      ? dispatch(disableLab(id))
      : dispatch(enableLab(id));
  };
};

export const fetchUserInfoIfNeeded = () => (dispatch, getState) => {
  if (getUserInfoLoadStatus(getState()) === DetailedLoadStatus.WAITING) {
    return dispatch(fetchUserInfoBase());
  }
};

export const updateUserLocale = (locale: string) => (dispatch) => {
  return dispatch(setUserInfo({ locale: getVstFromFullLocale(locale) }));
};

export const userSignOut = () => (dispatch) => {
  return dispatch(signOut());
};
